import { useEffect, useState } from "react";
import { instance } from '../utils/axios-config.js';
import { Box, CircularProgress, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useLocation, useParams } from 'react-router-dom';
import ModalInfo from '../components/ModalInfo.js';
import { useAuth } from "../context/Auth.js";
import ActionMessage from "../components/ActionMessage.js";
import DetallesComunidadComponent from "../components/DetallesBioVertebrados/DetallesComunidad.js";
import DetallesFincaCompletaComponent from "../components/DetallesBioVertebrados/DetallesFincaCompleta.js";
import Mensajes from "../utils/mensajes.js";



const BioVertebradosDetallesPage = () => {

    const {sessionToken} = useAuth();
    const { id } = useParams();
    const {state} = useLocation();

    const [ fincas, setFincas ] = useState([]);
    const [ finca, setFinca ] = useState({id: ""});
    const [ comunidades, setComunidades ] = useState([]);
    const [ comunidad, setComunidad ] = useState({id: ""});
    const [ bioVertebrados, setBioVertebrados ] = useState([]);
    const [ bioVertebradosFilter, setBioVertebradosFilter ] = useState([]);
    const [ bioVertebrado, setBioVertebrado ] = useState({id: ""});
    const [ bioVertebradosByYear, setBioVertebradosByYear ] = useState([]);
    const [ year, setYear ] = useState("");
    const [ loading, setLoading ] = useState(true);
    const [ loadingComunidades, setLoadingComunidades ] = useState(false);
    const [ loadingBios, setLoadingBios ] = useState(false);
    const [ msg, setMsg ] = useState( state ? state : undefined);
    const [ open, setOpen ] = useState(false);
    const [ error, setError ] = useState(false);
    const [ errorMsg, setErrorMsg ] = useState({open: false, title: "¡Vaya! Parece que algo ha ido mal.", content: "Algo ha fallado. Por favor, vuelve a intentarlo más tarde."});

    const [ data, setData ] = useState({
        labels: ['Bosquejo 1', 'Bosquejo 2', 'Bosquejo 3'],
        datasets: [
            {
              label: 'RIQUEZA ESPECIFICA',
              data: [0, 0, 0],
              backgroundColor: [
                'rgba(122,154,200, 0.8)',
                'rgba(128, 198, 6, 0.8)',
                'rgba(140, 228, 46, 0.8)'
              ],
              borderColor: [
                  'rgba(122,154,200, 0.8)',
                  'rgba(128, 198, 6, 0.8)',
                  'rgba(140, 228, 46, 0.8)'
              ],
              borderWidth: 2
            },
        ],
    });

    const [ infoData, setInfoData ] = useState({
        labels: ["Índice de Simpson (D)", ["Índice de Diversidad", "de Simpson (1 - D)"], ["Índice de equidad", "de Pielou (J')"]],
        datasets: [
            {
            data: [0, 0, 0],
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: 'rgba(128, 198, 6, 1)',
            borderWidth: 2,
            },
        ],
    });

    const backgroundColors = [
        'rgba(122,154,200, 0.8)',
        'rgba(128, 198, 6, 0.8)',
        'rgba(140, 228, 46, 0.8)',
        'rgba(255, 99, 132, 0.8)',
        'rgba(54, 162, 235, 0.8)',
        'rgba(255, 206, 86, 0.8)',
        'rgba(75, 192, 192, 0.8)',
        'rgba(153, 102, 255, 0.8)',
    ];

    useEffect(() => {
        if(state){
            loadAll();
        }else{
            loadPageData();
        }
    }, []);

    const loadAll = async () => {
        let buildFincasUrl = `/fincas/fincasByDataType/finca`;
        let buildComunidadesUrl = `/biodiversidad/comunidad-list/${state.fincaId}`;
        let buildBioVertebradosComunidadesUrl = `/biodiversidad/comunidades-biovertebrados-list/${state.fincaId}`;
        //let buildBioVegetalesUrl = `/biodiversidad/comunidad-biovegetal-list/${state.comunidadId}`;
        instance.defaults.headers.common = {'Authorization': `Bearer ${sessionToken}`}
        try{
            await Promise.all([instance.get(buildFincasUrl), instance.get(buildComunidadesUrl),instance.get(buildBioVertebradosComunidadesUrl)]).then(function(responses){
                setFincas(responses[0].data);

                let fnc = responses[0].data.find((f) => f.id === +state.fincaId);
                if (fnc) {
                    setFinca(fnc);
                }

                setComunidades(responses[1].data);
                let cmn;
                if(state.comunidadId === "FINCA COMPLETA"){
                    setComunidad({id: "FINCA COMPLETA"});
                    cmn = {id: "FINCA COMPLETA"};
                }else{
                    cmn = responses[1].data.find((c) => c.id === +state?.comunidadId);
                    if(cmn){
                        setComunidad(cmn);
                    }
                }

                let bVertebrados = responses[2].data.map((item) => {
                    let re = calculoRiquezaEspecifica(item);
                    item.riquezaEspecifica = re;
                    return item;
                });
                setBioVertebrados(bVertebrados);
                let bVertebradosFiltered = bVertebrados.filter(bv => bv.comunidad_id === cmn.id);
                setBioVertebradosFilter(bVertebradosFiltered);

                let yearBVertebrados = groupDataByYear(bVertebrados);
                setBioVertebradosByYear(yearBVertebrados);
                let bio = bVertebrados.find(bv => bv.id === +id);
                if(bio){
                    if(bio.tipoAnalisis === 0){
                        let resbv = calculosEnMuestras(bio);
                        setInfoData(prevState => ({
                            ...prevState,
                            datasets: prevState.datasets.map(dataset => ({
                                ...dataset,
                                data: [resbv.indiceSimpson, resbv.indiceDiversidadSimpson, resbv.indicePielou]
                            })),
                        }));
                        bio = resbv;
                    }else{
                        bio.especiesTotales = totalEspecies(bio);
                        bio.numEspeciesTotales = 0;
                    }
                    setBioVertebrado(bio);
                }
                if(state.year){
                    let bvs = yearBVertebrados[state.year];
                    if(bvs){
                        let mpc = muestrasPorComunidad(bvs);
                        setData(prevState => ({
                            ...prevState,
                            labels: mpc.labels,
                            datasets: prevState.datasets.map(dataset => ({
                                ...dataset,
                                data: mpc.data,
                                backgroundColor: chooseColor(mpc.data.length),
                            })),
                        }));
                        
                        setYear(state.year);
                    }
                }

            }).catch(function(error){
                setLoading(false);
                setOpen(true);
                setError(true);
                setErrorMsg((prevErrorMsg) => ({
                    ...prevErrorMsg,
                    content: "Algo ha fallado al intentar recuperar los datos. Por favor, vuelve a intentarlo más tarde."
                }));
            }).finally(()=>{
                setLoading(false);
            });

        }catch(error){
            setLoading(false);
            setOpen(true);
            setError(true);
            setErrorMsg((prevErrorMsg) => ({
                ...prevErrorMsg,
                content: "Algo ha fallado al intentar recuperar los datos. Por favor, vuelve a intentarlo más tarde."
            }));
        }
    }
    
    const loadPageData = async () => {
        let buildUrl = `/fincas/fincasByDataType/finca`;
        try{
            instance.defaults.headers.common = {'Authorization': `Bearer ${sessionToken}`}

            await instance.get(buildUrl).then(function(resp) {
                setFincas(resp.data);

            }).catch(function(resp) {
                setOpen(true);
                setError(true);
                setErrorMsg((prevErrorMsg) => ({
                    ...prevErrorMsg,
                    content: "Algo ha fallado al intentar recuperar la información de las fincas. Por favor, vuelve a intentarlo más tarde."
                }));
            }).finally(()=>{
                setLoading(false);
            });
        }catch(error){
            setLoading(false);
            setOpen(true);
            setError(true);
            setErrorMsg((prevErrorMsg) => ({
                ...prevErrorMsg,
                content: "Algo ha fallado al intentar recuperar la información de las fincas. Por favor, vuelve a intentarlo más tarde."
            }));
        }
    }

    const loadComunidadOnChange = async (fincaId) => {
        try{
            let buildUrl = `/biodiversidad/comunidad-list/${fincaId}`;
            let buildBioVertebradosComunidadesUrl = `/biodiversidad/comunidades-biovertebrados-list/${fincaId}`;

            setLoadingComunidades(true);
            instance.defaults.headers.common = {'Authorization': `Bearer ${sessionToken}`}

            //await instance.get(buildUrl).then(function(resp) {
            await Promise.all([instance.get(buildUrl), instance.get(buildBioVertebradosComunidadesUrl)]).then(function(resp) {
                //setComunidades(resp.data);
                setComunidades(resp[0].data);

                let bVertebrados = resp[1].data.map((item) => {
                    let re = calculoRiquezaEspecifica(item);
                    item.riquezaEspecifica = re;
                    return item;
                });
                setBioVertebrados(bVertebrados);

                let yearBVertebrados = groupDataByYear(bVertebrados);
                setBioVertebradosByYear(yearBVertebrados);

                let mpc = muestrasPorComunidad(resp[1].data);
                setData(prevState => ({
                    ...prevState,
                    labels: mpc.labels,
                    datasets: prevState.datasets.map(dataset => ({
                        ...dataset,
                        data: mpc.data,
                        backgroundColor: chooseColor(mpc.data.length),
                    })),
                }));
            }).catch(function(resp) {
                setOpen(true);
                setErrorMsg((prevErrorMsg) => ({
                    ...prevErrorMsg,
                    content: "Algo ha fallado al intentar recuperar las comunidades de la finca. Por favor, vuelve a intentarlo más tarde."
                }));
            }).finally(()=>{
                setLoadingComunidades(false);
            });
            setLoadingComunidades(false);
        }catch(error){
            setLoadingComunidades(false);
            setOpen(true);
            setErrorMsg((prevErrorMsg) => ({
                ...prevErrorMsg,
                content: "Algo ha fallado al intentar recuperar las comunidades de la finca. Por favor, vuelve a intentarlo más tarde."
            }));
        }
    }

    const loadBiosOnChange = async (comunidadId) => {
        try{
            setLoadingBios(true);
            let bVertebrados = bioVertebrados.filter(bv => bv.comunidad_id === comunidadId);
            setBioVertebradosFilter(bVertebrados);
            setLoadingBios(false);
        }catch(err){
            setLoadingBios(false);
            setOpen(true);
            setErrorMsg((prevErrorMsg) => ({
                ...prevErrorMsg,
                content: "Algo ha fallado al intentar recuperar las biodiversidades de vertebrados de la comunidad. Por favor, vuelve a intentarlo más tarde."
            }));
        }
    }

    const loadBioVertebradoOnChange = async (event) => {
        let comunidad = null;

        if(event.target.value === "FINCA COMPLETA"){
            setComunidad({id: "FINCA COMPLETA"});
        }else{
            let found = comunidades.find((obj) => obj.id === event.target.value);
            if (found) {
                comunidad = found;
            }
    
            setComunidad(comunidad);
    
            loadBiosOnChange(event.target.value);
        }

        setBioVertebrado({id: ""});
        setYear("");
    }

    const handleLoadComunidades = async (event) => {
        let finca = null;
        
        let found = fincas.find((obj) => obj.id === event.target.value);
        if (found) {
            finca = found;
        }

        setFinca(finca);
        setComunidad({id: ""});

        loadComunidadOnChange(event.target.value);
    }

    const handleFechaSelect = (event) => {
        let bv = bioVertebradosFilter.find((item) => item.id === event.target.value);
        if(bv){
            if(bv.tipoAnalisis === 0){
                let resbv = calculosEnMuestras(bv);
                setInfoData(prevState => ({
                    ...prevState,
                    datasets: prevState.datasets.map(dataset => ({
                        ...dataset,
                        data: [resbv.indiceSimpson, resbv.indiceDiversidadSimpson, resbv.indicePielou]
                    })),
                }));
                bv = resbv;
            }else{
                bv.especiesTotales = totalEspecies(bv);
                bv.numEspeciesTotales = 0;
            }
            setBioVertebrado(bv);
        }
    }

    const handleYearSelect = (event) => {
        let bvs = bioVertebradosByYear[event.target.value];
        if(bvs){
            let mpc = muestrasPorComunidad(bvs);
            setData(prevState => ({
                ...prevState,
                labels: mpc.labels,
                datasets: prevState.datasets.map(dataset => ({
                    ...dataset,
                    data: mpc.data,
                    backgroundColor: chooseColor(mpc.data.length),
                })),
            }));
            
            setYear(event.target.value);
        }
    }

    const chooseColor = (len) => {
        let bgColors = [];
        for(let i=0; i<len; i++){
            bgColors.push(backgroundColors[i % backgroundColors.length]);
        }
        return bgColors;
    }

    const calculoRiquezaEspecifica = (bv) => {
        const muestrasUnicas = new Set();
        bv.muestreos.forEach(muestreo => {
            muestreo.muestras.forEach(muestra => {
                muestrasUnicas.add(muestra.nombre);
            });
        });
        return muestrasUnicas.size;
    }


    const muestrasPorComunidad = (dataList) => {
        const comunidades = {};

        dataList.forEach(objeto => {
            const nombreComunidad = objeto.nombre_comunidad;

            if (!comunidades[nombreComunidad]) {
                comunidades[nombreComunidad] = new Set();
            }

            objeto.muestreos.forEach(muestreo => {
                muestreo.muestras.forEach(muestra => {
                    comunidades[nombreComunidad].add(muestra.nombre);
                });
            });
        });

        const labels = [];
        const data = [];

        Object.keys(comunidades).forEach(comunidad => {
            labels.push(comunidad);
            data.push(comunidades[comunidad].size);
        });

        return { labels, data };
    }

    const totalEspecies = (bv) => {
        const nombresUnicos = new Set();

        bv.muestreos.forEach(muestreo => {

            muestreo.muestras.forEach(muestra => {

                nombresUnicos.add(muestra.nombre);
            });
        });

        return Array.from(nombresUnicos);
    }

    /*const numTotalEspecies = (bv) => {
        let sumaTotal = 0;
        if(bv.tipoAnalisis === 0){
            let sumasPorNombre = {};
        
            bv.muestreos.forEach(muestreo => {
                let cantidad = muestreo.numMuestreos;
                muestreo.muestras.forEach(muestra => {
                    const nombre = muestra.nombre;
                    const ika = muestra.ika;

                    if (sumasPorNombre[nombre]) {
                        sumasPorNombre[nombre].suma += ika;
                    } else {
                        sumasPorNombre[nombre] = {
                        suma: ika,
                        cantidad: cantidad
                        };
                    }
                });
            });


            for (const nombre in sumasPorNombre) {
                const { suma, cantidad } = sumasPorNombre[nombre];

                if (cantidad > 1) {
                    const media = suma / cantidad;
                    sumaTotal += media;
                } else {
                    sumaTotal += suma;
                }
            }
        }
        return Math.ceil(sumaTotal);
    }*/

    const calculosEnMuestras = (bv) => {
        let sumasPorNombre = {};
        let sumaTotal = 0;
        let resultList = [];
        let indiceSimpson = 0;
        let indiceDiversidadSimpson = 0;
        let indicePielou = 0;
        let indiceShannonWiener = 0;
        bv.muestreos.forEach(muestreo => {
            let cantidad = muestreo.numMuestreos;
            muestreo.muestras.forEach(muestra => {
                const nombre = muestra.nombre;
                const ika = muestra.ika;
                const num_individuos = muestra.num_individuos;

                if (sumasPorNombre[nombre]) {
                    sumasPorNombre[nombre].suma += ika;
                    sumasPorNombre[nombre].sumaInd += num_individuos;
                } else {
                    sumasPorNombre[nombre] = {
                    suma: ika,
                    sumaInd: num_individuos,
                    cantidad: cantidad
                    };
                }
            });
        });

        for (const nombre in sumasPorNombre) {
            const { suma, cantidad } = sumasPorNombre[nombre];

            if (cantidad > 1) {
                const media = suma / cantidad;
                sumaTotal += media;
            } else {
                sumaTotal += suma;
            }
        }

        sumaTotal = Math.round(sumaTotal);

        for (const nombre in sumasPorNombre) {
            const { suma, cantidad, sumaInd } = sumasPorNombre[nombre];

            let pi;
            let pisquare;
            let h;
            let media = suma;
            if (cantidad > 1) {
                media = suma / cantidad;
                pi = (media/sumaTotal);
                pisquare = pi ** 2;
                h = getH(pi);
            } else {
                pi = (suma/sumaTotal);
                pisquare = pi ** 2;
                h = getH(pi);
            }
            indiceSimpson += pisquare;
            indiceShannonWiener += h;
            resultList.push({nombre: nombre, ika: media, nIndividuos: sumaInd, pi: pi, pisquare: pisquare, h: h});
        }

        indiceDiversidadSimpson = 1 - indiceSimpson;
        indicePielou = indiceShannonWiener / (Math.log(Object.keys(sumasPorNombre).length));

        bv.muestrasFiltradas = resultList;
        bv.numEspeciesTotales = Math.ceil(sumaTotal);
        bv.indiceSimpson = parseFloat(indiceSimpson.toFixed(2));
        bv.indiceDiversidadSimpson = parseFloat(indiceDiversidadSimpson.toFixed(2));
        bv.indicePielou = parseFloat(indicePielou.toFixed(2));
        bv.indiceShannonWiener = parseFloat(indiceShannonWiener.toFixed(2));

        return bv;
    }

    const getH = (pi) => {
        let res = 0;
        if(pi > 0){
            res = -(pi * Math.log(pi));
        }
        return res;
    }

    const groupDataByYear = (bVertebrados) => {
        const grouped = {};
        bVertebrados.forEach(obj => {
          const year = obj.fecha.split("/")[2];
          if (!grouped[year]) {
            grouped[year] = [];
          }
          grouped[year].push(obj);
        });
        return grouped;
    };
   
    return(
        <div className="width100">
            <div className="tic4bio-huella-section">VERTEBRADOS</div>

            <div className="tic4bio-home">
                {msg?.type &&
                    <ActionMessage msg={msg} setMsg={setMsg}/>
                }
                <Box component="form" noValidate sx={{ mt: 1 }}>
                    {loading ? 
                        (
                            <Box p={3} align="center">
                                <CircularProgress />
                            </Box>
                        ) : (
                            <>
                                <div>
                                    <h1 className="tic4bio-home-title">Biodiversidad vertebrados</h1>
                                    {!error ?
                                        <>
                                            {(fincas.length > 0) ?
                                                <>
                                                    <p>Seleccione la finca de la biodiversidad de vertebrados que desea visualizar*</p>
                                                    <FormControl sx={{width: "100%", marginBottom: "40px"}} variant="standard">
                                                        <InputLabel htmlFor="finca-select">Fincas*</InputLabel>
                                                        <Select
                                                            className="t4b-finca-sector-inputs"
                                                            id="finca-select"
                                                            label="Finca"
                                                            required
                                                            MenuProps={{ disableScrollLock: true }}
                                                            disabled={loadingComunidades}
                                                            value={finca.id}
                                                            onChange={(event) => { handleLoadComunidades(event) }    
                                                            }
                                                            >
                                                            
                                                            {fincas.map((finca, index) => (
                                                            <MenuItem key={index} value={finca.id}>
                                                                {finca.unidadProductiva} - {finca.nombre}
                                                            </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                    {loadingComunidades ? (
                                                        <Box p={3} align="center">
                                                            <CircularProgress />
                                                        </Box>
                                                        ) : (
                                                            <>
                                                                {finca.id &&
                                                                    <>
                                                                        {(comunidades.length > 0) ?
                                                                            <>
                                                                                <FormControl sx={{width: "100%", marginBottom: "40px"}} variant="standard">
                                                                                    <InputLabel htmlFor="comunidad-select">Comunidades*</InputLabel>
                                                                                    <Select
                                                                                        className="t4b-finca-sector-inputs"
                                                                                        id="comunidad-select"
                                                                                        label="Comunidad"
                                                                                        required
                                                                                        MenuProps={{ disableScrollLock: true }}
                                                                                        disabled={false}
                                                                                        value={comunidad.id}
                                                                                        onChange={(event) => { loadBioVertebradoOnChange(event) }
                                                                                        }>
                                                                                    
                                                                                        <MenuItem value={"FINCA COMPLETA"}>FINCA COMPLETA</MenuItem>
                                                                                        {comunidades.map((comunidad, index) => (
                                                                                            <MenuItem key={index} value={comunidad.id}>
                                                                                                {comunidad.nombre}
                                                                                            </MenuItem>
                                                                                        ))}
                                                                                    </Select>
                                                                                </FormControl>
                                                                                
                                                                                {loadingBios ? (
                                                                                    <Box p={3} align="center">
                                                                                        <CircularProgress />
                                                                                    </Box>
                                                                                    ) : (
                                                                                        <>
                                                                                            {(comunidad.id && comunidad.id !== "FINCA COMPLETA") &&
                                                                                                <>
                                                                                                    <DetallesComunidadComponent bioVertebrado={bioVertebrado} bioVertebrados={bioVertebradosFilter} handleFechaSelect={handleFechaSelect} infoData={infoData}/>
                                                                                                </>
                                                                                            }
                                                                                            {comunidad.id === "FINCA COMPLETA" &&
                                                                                                <>
                                                                                                    <DetallesFincaCompletaComponent year={year} bioVertebradosByYear={bioVertebradosByYear} handleYearSelect={handleYearSelect} data={data} />
                                                                                                </>
                                                                                            }
                                                                                        </>
                                                                                    )
                                                                                }
                                                                                                
                                                                            </>
                                                                            :
                                                                            <>
                                                                                <p>Parece que la finca seleccionada no tiene comunidades asociadas. Necesitas al menos una comunidad y añadir alguna biodiversidad de vertebrados para poder visualizar su detalle.</p>
                                                                            </>
                                                                        }
                                                                    </>
                                                                }
                                                            </>
                                                        )
                                                    }
                                                </>
                                                :
                                                <p><Mensajes type="vegetal"/></p>
                                            }
                                        </>
                                        :
                                        <>
                                            <p>Se ha producido un error inesperado. Vuelva a intentarlo más tarde.</p>
                                        </>
                                    }
                                    
                                </div>
                            </>
                        )
                    }
                </Box>
            </div>
            <ModalInfo open={open} setOpen={setOpen} contentTitle={errorMsg.title} contentText={errorMsg.content}/>
        </div>
    );
} 
export default BioVertebradosDetallesPage;